var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.022,
    height: 11.952,
    viewBox: "0 0 10.022 11.952",
    className: "user",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-user",
    transform: "translate(0.15 0.15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M89.838,5.613a2.716,2.716,0,0,0,1.984-.822,2.716,2.716,0,0,0,.822-1.984A2.716,2.716,0,0,0,91.823.822a2.806,2.806,0,0,0-3.969,0,2.716,2.716,0,0,0-.822,1.984,2.716,2.716,0,0,0,.822,1.984A2.717,2.717,0,0,0,89.838,5.613Z",
    transform: "translate(-85.051 0)",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M9.7,250.648a6.932,6.932,0,0,0-.094-.736,5.8,5.8,0,0,0-.181-.74,3.655,3.655,0,0,0-.3-.69,2.6,2.6,0,0,0-.459-.6A2.023,2.023,0,0,0,8,247.469a2.277,2.277,0,0,0-.842-.152.854.854,0,0,0-.456.193c-.137.089-.3.192-.475.306a2.724,2.724,0,0,1-.615.271,2.388,2.388,0,0,1-1.5,0,2.717,2.717,0,0,1-.614-.271l-.476-.307a.853.853,0,0,0-.456-.193,2.274,2.274,0,0,0-.841.152,2.022,2.022,0,0,0-.659.414,2.6,2.6,0,0,0-.459.6,3.663,3.663,0,0,0-.3.69,5.815,5.815,0,0,0-.181.74,6.883,6.883,0,0,0-.094.737c-.015.223-.023.454-.023.688A1.935,1.935,0,0,0,.574,252.8a2.069,2.069,0,0,0,1.481.54H7.666a2.069,2.069,0,0,0,1.481-.54,1.934,1.934,0,0,0,.575-1.464c0-.235-.008-.466-.024-.688Zm-1.022,1.657",
    transform: "translate(0 -241.688)",
    strokeWidth: 0.3
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.a39e552a6d9e8aa8a3fec16fdd7395eb.svg";
export { ForwardRef as ReactComponent };